import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment-timezone';

    

    var operatorFilterMap = {
        string: {
            '=': isEquals,
            'like': isLike,
            '!=': notEquals,
            'notlike': notLike,
            'startswith': startsWith,
            'endswith': endsWith
        },
        numeric: {
            '=': isEquals,
            '!=': notEquals,
            '<': lessThan,
            '<=': lessThanOrEqual,
            '>': greaterThan,
            '>=': greaterThanOrEqual
        },
        datetime: {
            '<': isPriorTo,
            '<=': isOnOrPrior,
            '>': isAfter,
            '>=': isOnOrAfter
        },
        tag: {
            '=': tagIsEquals,
            'like': tagIsLike,
            '!=': tagNotEquals,
            'notlike': tagNotLike
        },
    };

    var dateFormat = 'MM/DD/YYYY HH:mm:ss';

    function FilterFormatter() {
        var self = this;

        self.matchAnyOf = function (item, filters) {
            var matches = filters.filter(function (filter) {
                return self.match(item, filter);
            });

            return !!matches.length;
        };

        self.matchAll = function(item, filters) {
            var matches = filters.filter(function(filter) {
                return self.match(item, filter);
            });

            return matches.length === filters.length;
        };

        self.match = function (item, filter) {
            if (operatorFilterMap[filter.valueType] && operatorFilterMap[filter.valueType][filter.operator]) {
                return operatorFilterMap[filter.valueType][filter.operator](item, filter);
            }

            return false;
        };

        self.filters = {
            stringMatches: compareStrings
        };

    }

    function isEquals(item, filter) {
        if (filter.valueType === 'string') {
             return compareStrings(item[filter.name], filter.value);
        }

        return Number(item[filter.name]) === Number(filter.value);
    }

    function notEquals(item, filter) {
        return !isEquals(item, filter);
    }

    function isLike(item, filter) {
        return stringContains(_.toString(item[filter.name]), filter.value);
    }

    function notLike(item, filter) {
        return !isLike(item, filter);
    }

    function startsWith(item, filter){
        return _.startsWith(_.toString(_.toLower(item[filter.name])), _.toLower(filter.value));
    }
    
    function endsWith(item, filter){
        return _.endsWith(_.toString(_.toLower(item[filter.name])), _.toLower(filter.value));
    }

    function lessThan(item, filter) {
        return Number(item[filter.name]) < Number(filter.value);
    }

    function lessThanOrEqual(item, filter) {
        return Number(item[filter.name]) <= Number(filter.value);
    }

    function greaterThan(item, filter) {
        return Number(item[filter.name]) > Number(filter.value);
    }

    function greaterThanOrEqual(item, filter) {
        return Number(item[filter.name]) >= Number(filter.value);
    }

    function isPriorTo(item, filter) {
        return moment(item[filter.name], dateFormat).isBefore(moment(filter.value, dateFormat));
    }

    function isOnOrPrior(item, filter) {
        var endDate = moment(filter.value, dateFormat);
        var itemDate = moment(item[filter.name], dateFormat);

        // moment sets default time to 00:00:00
        if (endDate.hour() === 0 && endDate.isBefore(itemDate)) {
            endDate.add(1, "days");
        }

        return itemDate.isSameOrBefore(endDate);
    }

    function isAfter(item, filter) {
        return moment(item[filter.name], dateFormat).isAfter(moment(filter.value, dateFormat));
    }

    function isOnOrAfter(item, filter) {
        return moment(item[filter.name], dateFormat).isSameOrAfter(moment(filter.value, dateFormat));
    }

    function tagIsEquals(item, filter) {
        if (_.isEmpty(item) || _.isEmpty(filter) || !_.isString(item[filter.name])) {
            return false;
        }
        var tags = item[filter.name].split(',');
        var matches = false;

        for (var i = 0; i < tags.length; i++) {
            if (compareStrings(tags[i], filter.value)) {
                matches = true;
                break;
            }
        }

        return matches;
    }

    function tagIsLike(item, filter) {
        if (_.isEmpty(item) || _.isEmpty(filter) || !_.isString(item[filter.name])) {
            return false;
        }
        var tags = item[filter.name].split(',');
        var matches = false;

        for (var i = 0; i < tags.length; i++) {
            if (stringContains(tags[i], filter.value)) {
                matches = true;
                break;
            }
        }

        return matches;
    }

    function tagNotEquals(item, filter) {
        return !tagIsEquals(item, filter);
    }

    function tagNotLike(item, filter) {
        return !tagIsLike(item, filter);
    }

    //helpers
    function compareStrings(str1, str2) {
        return _.isString(str1) && _.isString(str2) && _.toLower(str1.trim()) === _.toLower(str2.trim());
    }

    function stringContains(str1, str2) {
        return _.isString(str1) && _.isString(str2) && _.toLower(str1.trim()).indexOf(_.toLower(str2.trim())) >= 0;
    }

    function arrayOrNull(item) {
        return _.isArray(item) ? item : null;
    }

    FilterFormatter.prototype.typeaheadToGridFilter = function(condition) {
        return { name: condition.selectedLhs, value: condition.rhsText, operator: condition.selectedOperator, valueType: condition.valueType };
    };

    FilterFormatter.prototype.filterToTypeaheadCondition = function(filter) {
        return { name: filter.columnKey, title: filter.columnDescription, type: filter.columnType };
    }

    FilterFormatter.prototype.toTypeaheadFilter = function(filterObj) {
        return _.chain(filterObj).get('search', null).thru(arrayOrNull).map(this.typeaheadToGridFilter).value();
    };

    FilterFormatter.prototype.dispose = function () {};

    export default FilterFormatter;

